var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-header pl-4 pr-4 pt-2 pb-2 mb-3"},[_c('h4',{staticClass:"m-0"},[_vm._t("icon"),_c('strong',[_vm._t("title")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }